import { Component, OnInit } from "@angular/core";
import { Certificate } from "crypto-pro";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
    selector: "app-certificate-list-popup",
    templateUrl: "./certificate-list-popup.component.html",
    styleUrls: ["./certificate-list-popup.component.scss"]
})
export class CertificateListPopupComponent implements OnInit {
    public certificateList?: Certificate[];
    public selectedCertificate?: Certificate;
    public closePendind?: () => void;

    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef,
    ) { }

    public ngOnInit(): void {
        this.setData();
    }

    public onRowSelect(event: any): void {
        this.selectedCertificate = event;
    }

    public onRowUnselect(): void {
        this.selectedCertificate = undefined;
    }

    public close(certificate?: Certificate): void {
        this.ref?.close(certificate);
    }

    public setData(): void {
        this.config.width = "1200px";
        this.config.header = $localize`Выберите сертификат`;
        for (let k in this.config.data) {
            (this as any)[k] = this.config.data[k];
        }
        this.config.height = "630px";
        if (this.closePendind) this.closePendind();
    }

    public checkSubjectName(sN: string, keys: string[], name: string): string {
        const subjectNameP1 = sN?.split(`${keys[0]}=`)[1]?.split(",")[0];
        const subjectNameP2 = sN?.split(`${keys[1]}=`)[1]?.split(",")[0];

        return !subjectNameP1 && !subjectNameP2 ? name : `${subjectNameP1 ?? ""} ${subjectNameP2 ?? ""}`;
    }

    public checkIssueName(iN: string): string {
        const issueName = iN?.split("CN=")[1]?.split(",")[0];
        
        return issueName;
    }

    public handleStr(str: string): string {
        return str.replace(/[A-Z]{1,}=/gm, "");
    }
}
